module.exports = __webpack_public_path__ + "media/assets/images/logo-white-00955197cfd0c0aef03125e7e9107e1a.png";